export default __webpack_public_path__ + "media/images/header-logo-d19f1dcd8e13dae81f5363a3b5e0c6ab.jpg";